import { useState } from "react"
import { Fuel } from "lucide-react"
import { ChatFuelReportDialog } from "./ChatFuelReportDialog"

interface FuelPercentButtonProps {
  fuelLevelLabel?: string
  fuelLitersLabel?: string
  driverJid: string | undefined
  chatJid: string
  enabled: boolean
}

export function FuelPercentButton({
  fuelLevelLabel,
  fuelLitersLabel,
  driverJid,
  chatJid,
  enabled,
}: FuelPercentButtonProps) {
  const [fuelDialogOpen, setFuelDialogOpen] = useState(false)
  const canOpenFuelReport = enabled && Boolean(driverJid)

  // Providers without a configured tank size report litres but no percentage,
  // so whichever reading exists leads and opens the report; the litres only
  // tag along when there is a percentage in front of them.
  const primaryLabel = fuelLevelLabel ?? fuelLitersLabel
  const secondaryLabel = fuelLevelLabel ? fuelLitersLabel : undefined

  if (!primaryLabel) return null

  return (
    <>
      <Fuel className="h-4 w-4 text-muted-foreground" />
      {canOpenFuelReport ? (
        <button
          className="text-muted-foreground hover:text-foreground hover:underline"
          onClick={() => setFuelDialogOpen(true)}
        >
          {primaryLabel}
        </button>
      ) : (
        <span className="text-muted-foreground">{primaryLabel}</span>
      )}
      {secondaryLabel && (
        <span className="text-muted-foreground">{secondaryLabel}</span>
      )}
      {canOpenFuelReport && driverJid && fuelDialogOpen && (
        <ChatFuelReportDialog
          driverJid={driverJid}
          chatJid={chatJid}
          open={true}
          onClose={() => setFuelDialogOpen(false)}
        />
      )}
    </>
  )
}
